import LoadingButton from '@/common/components/base/button/loadingButton';
import NumberInputWithWords from '@/common/components/base/numberInputWithWords/NumberInputWithWords';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import { requiredText } from '@/common/utils/rules/publicRules';
import { getOtherCostsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getOtherCosts/getOtherCostsQueryOption';
import { patchOtherCostQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchOtherCosts/patchOtherCostQueryOptions.ts';
import formatNumberWithCommas from '@/modules/adjusterReportModules/IncidentParticipants/utils/formatNumberWithCommas';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css/css';
import { Box, Flex } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="زیاندیده سایر/ کارشناسی" header="titleHeader">
      <OtherCosts />
    </MainLayout>
  );
};

const OtherCosts = () => {
  const { id, damagedId } = useParams();
  const navigate = useNavigate();
  const methods = useForm<{ parts_damage_total: string }>({
    mode: 'onChange',
  });

  const { data } = useQuery(
    getOtherCostsQueryOptions({ id: +id!, damaged_id: +damagedId! }),
  );

  const { mutate: updateCosts, isPending: patchPending } = useMutation(
    patchOtherCostQueryOptions(),
  );

  const onSubmit = (formData: { parts_damage_total: string }) => {
    updateCosts(
      {
        data: {
          ...formData,
          parts_transportation: 0,
          parts_damage_total: Number(
            (formData.parts_damage_total ?? '0').toString().replace(/,/g, ''),
          ),
        },
        damaged_id: +damagedId!,
        id: +id!,
      },
      {
        onSuccess: () => {
          navigate(-1);
        },
      },
    );
  };

  useEffect(() => {
    if (data) {
      methods.reset({
        ...data,
        parts_damage_total: formatNumberWithCommas(
          data?.parts_damage_total?.toString() ?? '0',
        ),
      });
    }
  }, [data, methods]);

  return (
    <Box pt={24}>
      <TitleDescription>هزینه‌ها</TitleDescription>
      <FormProvider {...methods}>
        <Flex
          direction="column"
          className={css({ height: '750px' })}
          gap={8}
          mt={24}
        >
          <Box>
            <NumberInputWithWords
              label="مبلغ خسارت"
              name="parts_damage_total"
              defaultValue="0"
              rules={{ required: requiredText }}
            />
          </Box>
          <Box pb={24} bottom={0} position={'fixed'} w={'90%'}>
            <LoadingButton
              onClick={methods.handleSubmit(onSubmit)}
              loading={patchPending}
              disabled={!methods?.formState?.isValid}
              fullWidth={true}
            >
              ثبت
            </LoadingButton>
          </Box>
        </Flex>
      </FormProvider>
    </Box>
  );
};
